/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContractNoticeDetailsUpdateRequest } from './contractNoticeDetailsUpdateRequest';

export interface UpdateContractNoticeRequest { 
    number?: string;
    procurementType?: UpdateContractNoticeRequest.ProcurementTypeEnum;
    description?: string;
    estimatedPurchaseValue?: number;
    currency?: UpdateContractNoticeRequest.CurrencyEnum;
    procedureType?: string;
    divisiblePurchase?: boolean;
    deliveryDate?: Date;
    publishedDate?: Date;
    url?: string;
    fileUrl?: string;
    status?: string;
    type?: UpdateContractNoticeRequest.TypeEnum;
    country?: UpdateContractNoticeRequest.CountryEnum;
    contractAuthorityId?: string;
    contractorIds?: Array<string>;
    mediumIds?: Array<string>;
    tagIds?: Array<string>;
    other?: { [key: string]: any; };
    details: Array<ContractNoticeDetailsUpdateRequest>;
    eauction?: boolean;
}
export namespace UpdateContractNoticeRequest {
    export type ProcurementTypeEnum = 'GOODS' | 'SERVICES' | 'WORKS' | 'OTHER';
    export const ProcurementTypeEnum = {
        GOODS: 'GOODS' as ProcurementTypeEnum,
        SERVICES: 'SERVICES' as ProcurementTypeEnum,
        WORKS: 'WORKS' as ProcurementTypeEnum,
        OTHER: 'OTHER' as ProcurementTypeEnum
    };
    export type CurrencyEnum = 'MKD' | 'EUR' | 'USD' | 'ALL';
    export const CurrencyEnum = {
        MKD: 'MKD' as CurrencyEnum,
        EUR: 'EUR' as CurrencyEnum,
        USD: 'USD' as CurrencyEnum,
        ALL: 'ALL' as CurrencyEnum
    };
    export type TypeEnum = 'CONTRACT_NOTICE' | 'E_MARKET' | 'CONCESSION' | 'DEFENSE_AND_SECURITY_LAW' | 'SPECIAL_SERVICES' | 'TECHNICAL_DIALOGUES';
    export const TypeEnum = {
        CONTRACTNOTICE: 'CONTRACT_NOTICE' as TypeEnum,
        EMARKET: 'E_MARKET' as TypeEnum,
        CONCESSION: 'CONCESSION' as TypeEnum,
        DEFENSEANDSECURITYLAW: 'DEFENSE_AND_SECURITY_LAW' as TypeEnum,
        SPECIALSERVICES: 'SPECIAL_SERVICES' as TypeEnum,
        TECHNICALDIALOGUES: 'TECHNICAL_DIALOGUES' as TypeEnum
    };
    export type CountryEnum = 'MK' | 'AL' | 'XK';
    export const CountryEnum = {
        MK: 'MK' as CountryEnum,
        AL: 'AL' as CountryEnum,
        XK: 'XK' as CountryEnum
    };
}